import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../locale/messages';

const smtpType = [
    { type: 'smtpName', key: 'smtpNameTooltip' },
    { type: 'smtpHost', key: 'smtpHostTooltip' },
    { type: 'smtpPort', key: 'smtpPortTooltip' },
    { type: 'smtpEmail', key: 'smtpEmailTooltip' },
    { type: 'smtpSender', key: 'smtpSenderTooltip' },
    { type: 'smtpSenderEmail', key: 'smtpSenderEmailTooltip' },
    { type: 'smtpPassword', key: 'smtpPassWordTooltip' }
];

export default function getSMTPToolTipType(type) {
    let result = smtpType.find(element => element.type === type);
    if (!result || !result.key) return type;
    else return (<FormattedMessage {...messages[result.key]} />);
}